import PropTypes from 'prop-types'
import React from 'react'
import ReactDOM from 'react-dom'

let modalContainer = null

class SimpleModalContainer extends React.Component {
  componentDidMount() {
    modalContainer = this.container
  }
  componentWillUnmount() {
    modalContainer = null
  }
  getWrappedInstance = () => {
    return this.container
  }
  render() {
    return (
      <div
        className="aspect-ratio--object z-9999 pointer-events-none"
        ref={(el) => {
          this.container = el
        }}
      />
    )
  }
}

export default class SimpleModal extends React.Component {
  render() {
    const { children, onClose } = this.props
    const tablet = window.innerWidth > 600
    const boxWidth = tablet ? 'w-80' : 'w-90'

    const modal = (
      <div className="flex justify-center items-center aspect-ratio--object z-9999 pointer-events-all">
        <div
          className="aspect-ratio--object bg-black-60 fade-in-animation"
          onClick={onClose}
        />
        <div
          className={`flex-none z-999 bg-base overflow-auto momentum w-60-l appear-animation ${boxWidth}`}
        >
          {children}
        </div>
      </div>
    )
    if (!modalContainer) return modal

    return ReactDOM.createPortal(modal, modalContainer)
  }
}

SimpleModal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
}

export { SimpleModalContainer }
